export default {
  methods: {
    goBack() {
      if (this.$route.path === '/home') {
        if (this.$isIos()) {
          window.webkit.messageHandlers.Cfinish.postMessage(null);
        } else {
          NativeApi.Cfinish();
        }
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  }
};
